import { jsx as e } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import { B as a } from "./BaseDecoratedButton-5on1OJrJ.mjs";
import "./ArrowButton-DqViaPQ-.mjs";
const n = r(
  (t, o) => /* @__PURE__ */ e(a, { buttonStyle: "primary", ref: o, ...t })
);
n.displayName = "PrimaryDecoratedButton";
const s = r(
  (t, o) => /* @__PURE__ */ e(a, { buttonStyle: "secondary", ref: o, ...t })
);
s.displayName = "SecondaryDecoratedButton";
const d = r(
  (t, o) => /* @__PURE__ */ e(a, { buttonStyle: "tertiary", ref: o, ...t })
);
d.displayName = "TertiaryDecoratedButton";
const y = r(
  (t, o) => /* @__PURE__ */ e(a, { buttonStyle: "ghost", ref: o, ...t })
);
y.displayName = "GhostDecoratedButton";
export {
  y as G,
  n as P,
  s as S,
  d as T
};
